import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { motion } from "framer-motion";
import "../../Styles/Admin/UserActivityHeatMap.css";
import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../../apiConfig";

const UserActivityHeatmap = () => {
  const [userActivityData, setUserActivityData] = useState([]);

  useEffect(() => {
    const fetchUserActivityData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/admin/user-activity`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("idToken")}`,
          },
        });

        const data = await response.json();
        if (data.success) {
          setUserActivityData(data.userActivityData);
        } else {
          console.error("Failed to fetch user activity data:", data.message);
        }
      } catch (err) {
        console.error("Error fetching user activity data:", err);
      }
    };

    fetchUserActivityData();
  }, []);

  return (
    <motion.div
      className="user-activity-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
    >
      <h2 className="user-activity-title">User Activity Heatmap</h2>
      <div className="chart-wrapper">
        <ResponsiveContainer>
          <BarChart data={userActivityData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
            <XAxis dataKey="name" stroke="#9CA3AF" />
            <YAxis stroke="#9CA3AF" />
            <Tooltip
              contentStyle={{
                backgroundColor: "rgba(31, 41, 55, 0.8)",
                borderColor: "#4B5563",
              }}
              itemStyle={{ color: "#E5E7EB" }}
            />
            <Legend />
            <Bar dataKey="0-4" stackId="a" fill="#6366F1" />
            <Bar dataKey="4-8" stackId="a" fill="#8B5CF6" />
            <Bar dataKey="8-12" stackId="a" fill="#EC4899" />
            <Bar dataKey="12-16" stackId="a" fill="#10B981" />
            <Bar dataKey="16-20" stackId="a" fill="#F59E0B" />
            <Bar dataKey="20-24" stackId="a" fill="#3B82F6" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </motion.div>
  );
};

export default UserActivityHeatmap;
